var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolplanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 783.1 200",
    style: {
      enableBackground: "new 0 0 783.1 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.6806,
    y1: 15.6116,
    x2: 749.0574,
    y2: 223.8968,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    style: {
      stopColor: "#FF2547"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3372,
    style: {
      stopColor: "#EA2752"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    style: {
      stopColor: "#B52D6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7549,
    style: {
      stopColor: "#603599"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#053FC8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.4,106c-0.8,1.2-1.6,2.1-2.5,3.3L169,140.2c-18.5-2.5-37.5-3.3-56.5-2.9c5.4-12.8,8.7-26.4,10.7-40 C150.9,95.7,177.7,99,202.4,106z M116.3,0.9c7.8,30.1,11.1,58.5,8.7,85.7c27.2,1.2,54,6.2,79.1,16.1c2.1-6.2,0.8-13.2-4.1-17.7 L116.3,0.9z M116.3,0.9L116.3,0.9L116.3,0.9L116.3,0.9z M270,77.6c10.3-3.3,19.4,0.4,26.4,2.9l7.4-10.7c-11.1-4.9-34.2-11.5-49-2.9 c-19.8,11.5-9.9,31.3,1.2,37.9c6.2,3.7,18.1,11.1,16.5,17.7c-3.7,12-25.1,8.2-30.5,6.6c-3.7-1.2-6.6-2.5-9.5-4.5l-0.8,15.7 c3.7,0.8,7.8,1.6,12,2.5c39.2,7,71.7-19.8,34.6-42l0,0c-10.7-6.2-14.8-11.1-14.8-16.1C263.8,81.3,266.7,78.4,270,77.6z M115,86.7 c-0.8-31.3-8.2-60.6-25.1-86.6L5,85c-6.2,6.2-6.6,16.1-1.2,22.7C39.6,93.7,77.5,86.2,115,86.7L115,86.7z M115,98.2 c-30.1,3.3-60.6,12.8-90.7,30.1l21,21c20.6-6.6,42.9-10.7,66.4-12C113.4,124.2,114.6,111,115,98.2z M168.6,140.6L168.6,140.6 L168.6,140.6L168.6,140.6z M90.3,195.1c6.6,6.6,17.3,6.6,24.3,0l54-54c-46.2,0-78.7,12-102.6,29.7L90.3,195.1z M474.8,141.1H495 l7.8-77.5h-20.6L474.8,141.1z M779.8,125.8L779.8,125.8L779.8,125.8L779.8,125.8z M676.8,118.8c0.4,17.7,33.8,9.9,41.6,7.4 l-2.1,10.7c-22.7,8.7-61.8,7.8-60.2-26c1.2-22.3,25.6-34.6,47-32.1l0,0C739.4,83.4,718.8,125.8,676.8,118.8z M706.9,94.1 c-8.7-13.2-28.9,0-30.1,14C677.2,110.6,713.1,108.5,706.9,94.1z M761.3,100.7h20.6l1.2-11.5h-20.2l1.2-9.9h-19.8l-1.2,9.9h-14.4 l-1.2,11.5h14l-2.9,23.9c-2.9,21.4,27.2,18.5,39.2,11.1l2.5-9.9c-6.2,3.3-22.3,6.2-21-4.5L761.3,100.7z M600.5,90.8l1.2-11.1H582 l-6.2,61.8h19.8l3.3-33c1.6-18.5,32.6-20.2,31.3-4.9l-3.7,37.9h19.8l4.1-44.5C652.5,73.9,612.9,78,600.5,90.8z M504.9,120.5 c2.1,22.3,24.7,21.8,36.3,19l1.2-11.1c-34.6,2.9-18.1-41.6,10.3-31.7l-4.9,44.5h19.4l4.5-44.9C574.2,68.5,500.4,75.1,504.9,120.5z  M375.5,63.6l-7.8,77.5h19.8l7.8-77.5H375.5z M364,110.1c0,17.3-14,31.7-31.7,31.7c-17.3,0-31.7-14-31.7-31.7 c0-17.3,14-31.7,31.7-31.7C350,78.8,364,92.8,364,110.1z M346.2,104l13.6-9.1l-14.8,6.6c-2.5,0.4-4.1-1.2-3.7-3.3l7.4-14.8 l-9.9,13.2c-2.1,1.6-4.5,0.8-4.9-1.6l-1.6-16.1l-1.6,16.1c-0.4,2.9-2.9,3.7-4.9,1.6l-9.5-13.2l7.4,14.8c0.4,2.1-1.2,3.7-3.7,3.3 L305,95.3l13.6,9.1c1.6,1.2,1.2,4.5-2.5,4.9l-15.3,1.2l14.8,0.8c3.3,0.4,4.9,3.3,2.1,5.8L305,125l14-5.8c3.7-1.2,5.4,2.1,3.7,4.5 l-6.2,13.2l8.7-12c1.6-2.5,4.9-2.5,5.4,0.8l1.2,15.7l1.2-15.7c0.4-3.3,4.1-3.3,5.4-0.8l8.7,12l-6.2-13.2c-1.6-2.9,0-5.8,3.7-4.5 l14,5.8l-12.8-7.8c-2.9-2.5-1.2-5.4,2.1-5.8l14.8-0.8l-15.3-1.2C345,108.9,344.6,105.6,346.2,104z M461.6,87.5 c23.1,23.1-3.7,64.3-45.8,51.1l-2.9,29.3h-19.4l7-70.9C406.4,80.5,446.4,71.8,461.6,87.5L461.6,87.5z M449.3,99.4 c-5.8-7.4-23.9-7.4-29.7,1.6l-1.6,21c-0.4,5.8,12.4,6.6,22.7,3.7C448.9,122.9,456.7,108.9,449.3,99.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolplanet);
export default __webpack_public_path__ + "static/media/solplanet.b95a54dd23854cc432ba47d6dc869cf3.svg";
export { ForwardRef as ReactComponent };